<script>
import { priceStatusFilter } from '@utils/filter-value-to-text';
import productMixin from '@/src/mixins/product';

const initData = () => {
  return {
    productId: '',
    title: '',
    state: 0,
    basePrice: 0,
    storeTitle: '',
    price: 0,
    serviceTime: 90,
    bufferTime: 30,
    isFlexible: 0,
    categoryId: 0,
    petCategoryTitle: '',
    petSizeTitle: '',
  };
};

export default {
  components: {
  },
  filters: {
    priceStatusFilter,
  },
  mixins: [productMixin],
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    categoryIndex: {
      type: Number,
      default: 0,
    },
    categoryId: {
      type: Number,
      default: 0,
    },
    defaultValue: {
      type: Object,
      default: () => { },
    },
    templateType: {
      type: String,
      required: true,
    },
    productList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      isOrderManager: true,
      tableData: [],
      filterData: {
        productId: '',
        spec: '',
      },
      priceData: {},
      formIndex: 0,
      dialogVisible: false,
      exportType: '',
      tryingFetch: false,
      inventoryExNumber: 0, // 庫存預設值
    };
  },
  inject: ['routerType'],
  computed: {
    formRules() {
      return {
      }
    },
    submitData: {
      get() {
        return this.defaultValue;
      },
      set(value) {
        this.$emit('update:defaultValue', value);
      },
    },
    submitRules() {
      return {
        serviceTime: [
          {
            required: true,
            message: '請輸入服務時間',
            trigger: 'change',
          },
        ],
        bufferTime: [
          {
            required: true,
            message: '請輸入緩衝時間',
            trigger: 'change',
          },
        ],
        basePrice: [
          {
            required: true,
            message: '請輸入原始價格',
            trigger: 'change',
          },
        ],
        price: [
          {
            required: true,
            message: '請輸入販售價格',
            trigger: 'change',
          },
        ],
      };
    },
    isEditMode() {
      return this.defaultValue.id;
    },
    /**
     * @description filter 過後的tableData
     */
    filterTableData() {
      let result = this.tableData
      if (this.filterData.productId.length > 0) {
        result = this.tableData.filter(item => {
          return item.productId === this.filterData.productId
        })
      }
      if (this.filterData.spec.length > 0) {
        result = this.tableData.filter(item => {
          return item.specTagCutArr.some(specItem => {
            return JSON.stringify(specItem) === JSON.stringify(this.filterData.spec)
          })
        })
      }
      return result
    },
    /**
     * @description 找出所有規格
     */
    allSpecTagArr() {
      let result = this.tableData.reduce((accu, cur) => {
        if (cur.hasOwnProperty('specTagCutArr')) {
          cur.specTagCutArr.forEach(specTagArr => {
            let specTagStr = specTagArr.join('：')
            if (!accu[specTagStr]) {
              accu[specTagStr] = specTagArr
            }
          })
        }
        return accu
      }, {})
      return result
    }
  },
  watch: {
    submitData: {
      handler(nvl, ovl) {
        this.setTableData();
      },
      deep: true
    },
  },
  created() {
    this.setTableData()
  },
  mounted() {
  },
  methods: {
    /**
     * @description 看庫存數量是否可以被輸入
     */
    disableStatusForInventory(row) {
      if (typeof row.id === 'string' && row.id.includes('fake')) {
        return false
      }
      if (typeof row.id === 'number' && row.id) {
        return true
      }
      if (row.id === null) {
        return false
      }
    },
    tryToFetchList() {

    },
    generateCode() {

    },
    /**
     * @description 看此列是否可以被勾選
     * @param {*} index 
     */
    canSelect(row, index) {
      return 1
    },
    /**
     * @description 重置filter資料
     */
    resetFilterData() {
      Object.keys(this.filterData).forEach(item => {
        this.$set(this.filterData, item, '')
      })
    },
    /**
     * @description 當blur時，去修改貨號
     */
    changeGoodsNo(row) {
      this.$set(row, 'no', row.noCutArr.join('-'))
    },
    /**
     * @description 除貨號外，皆同第一列
     */
    toAllCategory() {
      try {
        if (this.filterTableData.length === 0) {
          return
        }
        const { state, inventory, prices } = this.filterTableData[0];
        const toFindFilterIdArr = this.filterTableData.map(item => item.id)
        for (let i = 0, len = this.tableData.length; i < len; i++) {
          const { id } = this.tableData[i]
          if (toFindFilterIdArr.includes(id)) {
            this.$set(this.tableData[i].prices[0], 'basePrice', prices[0].basePrice);
            this.$set(this.tableData[i].prices[0], 'price', prices[0].price);
            this.$set(this.tableData[i].prices[0], 'costPrice', prices[0].costPrice);
            this.$set(this.tableData[i], 'inventory', inventory);
            this.$set(this.tableData[i], 'state', state);
          }
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 設定table資料
     */
    setTableData() {
      if (this.submitData.petSizes) {
        this.tableData = this.submitData.petSizes.filter(item => item.state === 1 || item.state === 0);
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    handleSelectionChange(selected) {
      this.$emit('updateSelectedPrices', selected);
    },
    /**
     * @description 因為vue無法監聽太深的值，所以儲存前要再更改過其變動的值，並且改變值的狀態
     */
    transformIntoArray() {
      this.$set(this.priceData.prices[0], 'basePrice', +this.priceData.basePrice);
      this.$set(this.priceData.prices[0], 'price', +this.priceData.price);
      this.$set(this.priceData.prices[0], 'isFlexible', +this.priceData.isFlexible);
      this.priceData.serviceTime = +this.priceData.serviceTime;
      this.priceData.bufferTime = +this.priceData.bufferTime;
    },
    validatePriceData() {
      try {
        let validate = true;
        const { basePrice, bufferTime, serviceTime, price } = this.priceData;
        if (parseInt(bufferTime) < 0) validate = false;
        if (parseInt(serviceTime) < 0) validate = false;
        if (parseInt(basePrice) < 0) validate = false;
        if (parseInt(price) < 0) validate = false;
        if (!validate) {
          this.$message({
            type: 'error',
            message: `各欄位皆需大於等於0`,
          });
        }
        return validate;
      } catch (error) {
        console.error(error.message);
      }
    },
    async tryToSave() {
      try {
        if (!this.validatePriceData()) return;
        await this.$refs.form.validate();
        if (this.isEditMode) {
          this.transformIntoArray();
          const changeDataId = this.priceData.id;
          this.tableData.forEach((item, index) => {
            if (changeDataId === item.id) {
              this.tableData[index] = { ...this.priceData };
            }
          });
          this.$emit('store', 'price');
        } else {
          this.tableData.forEach((item, index) => {
            if (this.priceData.catchId === item.catchId) {
              this.tableData[index] = { ...this.priceData };
            }
          });
          this.tableData = [...this.tableData];
          this.submitData.prices = [...this.tableData];
        }
        this.dialogVisible = false;
      } catch {
      } finally {
      }
    },
    tryToFetchListFilter() { },
    onFilterReset() { },
    /**
     * @description 上架商品
     */
    async selectOn() {
      const ids = this.selectedPrices.map((item) => item.id);
      const url = 'product/serviceUpdateState'
      await this.$store.dispatch(`${url}`, {
        ids,
        state: 1,
      });
      this.$emit('update');
    },
    /**
     * @description 下架商品
     */
    async selectOff() {
      try {
        await this.$confirm('服務上架中，確定要下架嗎？', '確認下架', {
          confirmButtonText: '確定',
          showCancelButton: true,
          type: 'warning',
          center: true,
        });
        const ids = this.selectedPrices.map((item) => item.id);
        const url = 'product/serviceUpdateState'
        await this.$store.dispatch(`${url}`, {
          ids,
          state: 0,
        });
        this.$emit('update');
      } catch {
      } finally {
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<template>
  <div :class="$style.content">
    <el-form ref="form" :model="submitData" :rules="formRules" :validate-on-rule-change="false" label-position="top"
      :class="[$style.form]" autocomplete="off">
      <el-row>
        <BaseTableSearch v-slot="{ fields }" class="priceTableDisplay" hide-action :default-value.sync="filterData"
          :class="$style.filter" @reset="resetFilterData" @tryToFetchList="tryToFetchListFilter">
          <el-form-item prop="productId" style="width: 20%" class="formItemDisplay">
            <el-select v-model="fields.productId" placeholder="選擇分店" @change="tryToFetchListFilter">
              <el-option label="所有分店" value></el-option>
              <el-option v-for="(product, index) in products" :key="`product-${index}`" :label="product.name"
                :value="product.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="productId" style="width: 20%" class="formItemDisplay">
            <el-select v-model="fields.spec" placeholder="選擇分店" @change="tryToFetchListFilter">
              <el-option label="所有規格" value></el-option>
              <el-option v-for="(specKey, specIndex) in Object.keys(allSpecTagArr)" :key="`spec-${specIndex}`"
                :label="specKey" :value="allSpecTagArr[specKey]"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="productId" style="width: 25%" class="formItemDisplay">
            <el-button type="primary" class="is-round" @click="toAllCategory">
              除貨號外，皆同第一列
            </el-button>
          </el-form-item>
        </BaseTableSearch>
      </el-row>
      <el-row>
        <el-table v-if="filterTableData.length > 0" ref="multipleTable" v-loading="tryingFetch" :data="filterTableData"
          element-loading-text="取得服務資訊中" style="padding:15px 20px 20px"
          @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" label="全選" width="120" :selectable='canSelect' disabled='true'>
          </el-table-column> -->
          <el-table-column v-slot="{ row }" label="分店及規格" prop="type" min-width="180">
            <div>
              {{ row.storeTitle }}
            </div>
            <div v-for="(item, index) in row.specTagCutArr" :key="`spec-${index}`">
              <div>
                <span>{{ item[0] }}：</span>
                <span>{{ item[1] }}</span>
              </div>
            </div>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="原價（NT$）" prop="type" min-width="120">
            <el-input v-model.number="row.prices[0].basePrice" :min="0" type="number" :placeholder="inventoryExNumber"
              class="is-border bg-white"></el-input>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="售價（NT$）" prop="type" min-width="120">
            <el-input v-model.number="row.prices[0].price" :min="0" type="number" :placeholder="inventoryExNumber"
              class="is-border bg-white"></el-input>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="成本價（NT$）" prop="type" min-width="140">
            <el-input v-model.number="row.prices[0].costPrice" :min="0" type="number" :clearable="true"
              :placeholder="inventoryExNumber" class="is-border bg-white"></el-input>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="商品貨號" prop="type" min-width="250">
            <template v-if="row.hasOwnProperty('noCutArr')">
              <span>{{ row.noCutArr[0] }} - </span>
              <el-input v-model="row.noCutArr[1]" placeholder="" style="width: 80px" class="is-border bg-white"
                @blur="changeGoodsNo(row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="庫存數量" prop="type" min-width="150">
            <el-input v-model="row.inventory" type="number" :disabled="disableStatusForInventory(row)"
              :placeholder="inventoryExNumber" class="is-border bg-white"></el-input>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="上架" prop="type" min-width="170">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0"></el-switch>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="條碼" prop="type" min-width="100">{{ row.feature }} </el-table-column>
        </el-table>
      </el-row>
    </el-form>
  </div>
</template>

<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';

.content {
  background-color: white;
  margin-bottom: 20px;

  &__salesPriceSpace {
    padding: 14px 10px;
    background-color: $color-line;
    margin-left: 0 !important; // 要蓋掉:gutter=24 -> 因為內部還是需要gutter，el-col需要
    margin-right: 0 !important;
  }
}


.tableDisplay {
  margin-top: 30px;

  :global {
    .titleAndBtnDisplay {
      display: flex;
      justify-content: space-between;
    }
  }
}

.filter {
  display: flex;
  align-items: center;

  :global {
    .formItemDisplay {
      margin-bottom: 0;
    }

    .priceTableDisplay {
      padding: 20px !important;
    }
  }
}
</style>